import { useStorage } from './useStorage'
import { STORAGE_TABLE_GROUP, STORAGE_TABLE_GROUP_VERSION } from '@/config/storageDatabase'

import moment from 'moment'

export function useRecentUsersStorage({ groupID  }) {
  const storage = useStorage({
    table: STORAGE_TABLE_GROUP,
    version: STORAGE_TABLE_GROUP_VERSION
  })

  function getRecentUsers() {
    return storage.get({ key: groupID, fallback: [] })
  }

  function addRecentUsers({ userID }) {
    const now = moment.utc().unix()
    const list = getRecentUsers()
    const exists = list.find(u => u.userID === userID)

    if (exists) {
      exists.date = now
    } else {
      list.unshift({ userID, date: now })
    }

    storage.set({
      key: groupID,
      value: list
    })
    // storage.set(key, list.slice(0, 25)) // limite opcional
  }

  return { getRecentUsers, addRecentUsers }
}
